<script>
  import { slide } from "svelte/transition";
  export let isMobile = false;
  export let isOpen = false;
</script>

{#if isMobile}
  {#if isOpen}
    <div class="burger-menu" transition:slide={{ duration: 200 }}>
      <slot />
    </div>
  {/if}
{:else}
  <slot />
{/if}

<style>
  .burger-menu {
    display: flex;
    flex-direction: column;
    position: absolute;
    bottom: 50px;
    background: var(--org-color-gray-900);
    border-radius: 5%;
    box-shadow: 0px -6px 20px rgba(0, 0, 0, 0.8);
  }
</style>
